import { render, staticRenderFns } from "./kw_file_preview.vue?vue&type=template&id=6c99ea52&scoped=true&"
import script from "./kw_file_preview.vue?vue&type=script&lang=js&"
export * from "./kw_file_preview.vue?vue&type=script&lang=js&"
import style0 from "./kw_file_preview.vue?vue&type=style&index=0&id=6c99ea52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99ea52",
  null
  
)

component.options.__file = "kw_file_preview.vue"
export default component.exports